// extracted by mini-css-extract-plugin
export default {"homeColumn":"index_homeColumn_Q891k"};